import { forwardRef } from 'react';
import { NumericFormat, NumericFormatProps } from 'react-number-format';
import { TextFieldProps } from '@mui/material';

import { TextField } from './TextField';

export type NumberFieldProps = Pick<
  NumericFormatProps,
  | 'allowedDecimalSeparators'
  | 'allowLeadingZeros'
  | 'allowNegative'
  | 'decimalScale'
  | 'decimalSeparator'
  | 'fixedDecimalScale'
  | 'onValueChange'
  | 'prefix'
  | 'suffix'
  | 'thousandSeparator'
  | 'thousandsGroupStyle'
  | 'value'
> &
  Pick<
    TextFieldProps,
    | 'color'
    | 'disabled'
    | 'error'
    | 'FormHelperTextProps'
    | 'helperText'
    | 'InputLabelProps'
    | 'InputProps'
    | 'label'
    | 'name'
    | 'onBlur'
    | 'onFocus'
    | 'required'
    | 'slotProps'
    | 'variant'
  >;

const NumberField = forwardRef<HTMLInputElement, NumberFieldProps>((props, ref) => (
  <NumericFormat customInput={TextField} inputRef={ref} {...props} />
));

export default NumberField;
